import { g as ar } from "./_commonjsHelpers-c5d32002.js";
import { _ as nr, a as tr, e as sr, i as z, b as ir, c as fr, d as ur, f as vr, g as b, h as lr, j as gr, k as _r, l as yr, m as or } from "./isArrayLike-7c53ca11.js";
import { c as pr, d as E, _ as Ar, i as dr } from "./isObjectLike-94d3a5fe.js";
var $r = "__lodash_hash_undefined__";
function cr(r) {
  return this.__data__.set(r, $r), this;
}
var Tr = cr;
function wr(r) {
  return this.__data__.has(r);
}
var Or = wr, Sr = nr, Pr = Tr, br = Or;
function P(r) {
  var e = -1, a = r == null ? 0 : r.length;
  for (this.__data__ = new Sr(); ++e < a; )
    this.add(r[e]);
}
P.prototype.add = P.prototype.push = Pr;
P.prototype.has = br;
var Er = P;
function Lr(r, e) {
  for (var a = -1, n = r == null ? 0 : r.length; ++a < n; )
    if (e(r[a], a, r))
      return !0;
  return !1;
}
var mr = Lr;
function Cr(r, e) {
  return r.has(e);
}
var Mr = Cr, hr = Er, Dr = mr, qr = Mr, Ir = 1, Rr = 2;
function Kr(r, e, a, n, s, t) {
  var i = a & Ir, v = r.length, u = e.length;
  if (v != u && !(i && u > v))
    return !1;
  var l = t.get(r), o = t.get(e);
  if (l && o)
    return l == e && o == r;
  var g = -1, f = !0, p = a & Rr ? new hr() : void 0;
  for (t.set(r, e), t.set(e, r); ++g < v; ) {
    var _ = r[g], y = e[g];
    if (n)
      var A = i ? n(y, _, g, e, r, t) : n(_, y, g, r, e, t);
    if (A !== void 0) {
      if (A)
        continue;
      f = !1;
      break;
    }
    if (p) {
      if (!Dr(e, function(d, $) {
        if (!qr(p, $) && (_ === d || s(_, d, a, n, t)))
          return p.push($);
      })) {
        f = !1;
        break;
      }
    } else if (!(_ === y || s(_, y, a, n, t))) {
      f = !1;
      break;
    }
  }
  return t.delete(r), t.delete(e), f;
}
var k = Kr;
function xr(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n, s) {
    a[++e] = [s, n];
  }), a;
}
var Gr = xr;
function Nr(r) {
  var e = -1, a = Array(r.size);
  return r.forEach(function(n) {
    a[++e] = n;
  }), a;
}
var Br = Nr, R = pr, K = tr, Hr = sr, Fr = k, Ur = Gr, Wr = Br, jr = 1, Jr = 2, Qr = "[object Boolean]", Xr = "[object Date]", Yr = "[object Error]", Zr = "[object Map]", Vr = "[object Number]", zr = "[object RegExp]", kr = "[object Set]", re = "[object String]", ee = "[object Symbol]", ae = "[object ArrayBuffer]", ne = "[object DataView]", x = R ? R.prototype : void 0, L = x ? x.valueOf : void 0;
function te(r, e, a, n, s, t, i) {
  switch (a) {
    case ne:
      if (r.byteLength != e.byteLength || r.byteOffset != e.byteOffset)
        return !1;
      r = r.buffer, e = e.buffer;
    case ae:
      return !(r.byteLength != e.byteLength || !t(new K(r), new K(e)));
    case Qr:
    case Xr:
    case Vr:
      return Hr(+r, +e);
    case Yr:
      return r.name == e.name && r.message == e.message;
    case zr:
    case re:
      return r == e + "";
    case Zr:
      var v = Ur;
    case kr:
      var u = n & jr;
      if (v || (v = Wr), r.size != e.size && !u)
        return !1;
      var l = i.get(r);
      if (l)
        return l == e;
      n |= Jr, i.set(r, e);
      var o = Fr(v(r), v(e), n, s, t, i);
      return i.delete(r), o;
    case ee:
      if (L)
        return L.call(r) == L.call(e);
  }
  return !1;
}
var se = te;
function ie(r, e) {
  for (var a = -1, n = e.length, s = r.length; ++a < n; )
    r[s + a] = e[a];
  return r;
}
var fe = ie, ue = fe, ve = z;
function le(r, e, a) {
  var n = e(r);
  return ve(r) ? n : ue(n, a(r));
}
var ge = le;
function _e(r, e) {
  for (var a = -1, n = r == null ? 0 : r.length, s = 0, t = []; ++a < n; ) {
    var i = r[a];
    e(i, a, r) && (t[s++] = i);
  }
  return t;
}
var ye = _e;
function oe() {
  return [];
}
var pe = oe, Ae = ye, de = pe, $e = Object.prototype, ce = $e.propertyIsEnumerable, G = Object.getOwnPropertySymbols, Te = G ? function(r) {
  return r == null ? [] : (r = Object(r), Ae(G(r), function(e) {
    return ce.call(r, e);
  }));
} : de, we = Te, Oe = ir, Se = Oe(Object.keys, Object), Pe = Se, be = fr, Ee = Pe, Le = Object.prototype, me = Le.hasOwnProperty;
function Ce(r) {
  if (!be(r))
    return Ee(r);
  var e = [];
  for (var a in Object(r))
    me.call(r, a) && a != "constructor" && e.push(a);
  return e;
}
var Me = Ce, he = ur, De = Me, qe = vr;
function Ie(r) {
  return qe(r) ? he(r) : De(r);
}
var Re = Ie, Ke = ge, xe = we, Ge = Re;
function Ne(r) {
  return Ke(r, Ge, xe);
}
var Be = Ne, N = Be, He = 1, Fe = Object.prototype, Ue = Fe.hasOwnProperty;
function We(r, e, a, n, s, t) {
  var i = a & He, v = N(r), u = v.length, l = N(e), o = l.length;
  if (u != o && !i)
    return !1;
  for (var g = u; g--; ) {
    var f = v[g];
    if (!(i ? f in e : Ue.call(e, f)))
      return !1;
  }
  var p = t.get(r), _ = t.get(e);
  if (p && _)
    return p == e && _ == r;
  var y = !0;
  t.set(r, e), t.set(e, r);
  for (var A = i; ++g < u; ) {
    f = v[g];
    var d = r[f], $ = e[f];
    if (n)
      var I = i ? n($, d, f, e, r, t) : n(d, $, f, r, e, t);
    if (!(I === void 0 ? d === $ || s(d, $, a, n, t) : I)) {
      y = !1;
      break;
    }
    A || (A = f == "constructor");
  }
  if (y && !A) {
    var w = r.constructor, O = e.constructor;
    w != O && "constructor" in r && "constructor" in e && !(typeof w == "function" && w instanceof w && typeof O == "function" && O instanceof O) && (y = !1);
  }
  return t.delete(r), t.delete(e), y;
}
var je = We, Je = b, Qe = E, Xe = Je(Qe, "DataView"), Ye = Xe, Ze = b, Ve = E, ze = Ze(Ve, "Promise"), ke = ze, ra = b, ea = E, aa = ra(ea, "Set"), na = aa, ta = b, sa = E, ia = ta(sa, "WeakMap"), fa = ia, C = Ye, M = lr, h = ke, D = na, q = fa, rr = Ar, T = gr, B = "[object Map]", ua = "[object Object]", H = "[object Promise]", F = "[object Set]", U = "[object WeakMap]", W = "[object DataView]", va = T(C), la = T(M), ga = T(h), _a = T(D), ya = T(q), c = rr;
(C && c(new C(new ArrayBuffer(1))) != W || M && c(new M()) != B || h && c(h.resolve()) != H || D && c(new D()) != F || q && c(new q()) != U) && (c = function(r) {
  var e = rr(r), a = e == ua ? r.constructor : void 0, n = a ? T(a) : "";
  if (n)
    switch (n) {
      case va:
        return W;
      case la:
        return B;
      case ga:
        return H;
      case _a:
        return F;
      case ya:
        return U;
    }
  return e;
});
var oa = c, m = _r, pa = k, Aa = se, da = je, j = oa, J = z, Q = yr, $a = or, ca = 1, X = "[object Arguments]", Y = "[object Array]", S = "[object Object]", Ta = Object.prototype, Z = Ta.hasOwnProperty;
function wa(r, e, a, n, s, t) {
  var i = J(r), v = J(e), u = i ? Y : j(r), l = v ? Y : j(e);
  u = u == X ? S : u, l = l == X ? S : l;
  var o = u == S, g = l == S, f = u == l;
  if (f && Q(r)) {
    if (!Q(e))
      return !1;
    i = !0, o = !1;
  }
  if (f && !o)
    return t || (t = new m()), i || $a(r) ? pa(r, e, a, n, s, t) : Aa(r, e, u, a, n, s, t);
  if (!(a & ca)) {
    var p = o && Z.call(r, "__wrapped__"), _ = g && Z.call(e, "__wrapped__");
    if (p || _) {
      var y = p ? r.value() : r, A = _ ? e.value() : e;
      return t || (t = new m()), s(y, A, a, n, t);
    }
  }
  return f ? (t || (t = new m()), da(r, e, a, n, s, t)) : !1;
}
var Oa = wa, Sa = Oa, V = dr;
function er(r, e, a, n, s) {
  return r === e ? !0 : r == null || e == null || !V(r) && !V(e) ? r !== r && e !== e : Sa(r, e, a, n, er, s);
}
var Pa = er, ba = Pa;
function Ea(r, e) {
  return ba(r, e);
}
var La = Ea;
const ha = /* @__PURE__ */ ar(La);
export {
  Pa as _,
  na as a,
  Br as b,
  Er as c,
  Mr as d,
  ha as i,
  Re as k
};
//# sourceMappingURL=isEqual-24663bfb.js.map
